import { useSyncExternalStore } from 'react';

/**
 * Tiny typed store for the "session expired" dialog. The query client's global error handler
 * opens it (outside React); the dialog subscribes to it.
 */
export interface SessionExpiredStore {
  open: () => void;
  close: () => void;
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => boolean;
}

export function createSessionExpiredStore(): SessionExpiredStore {
  let isOpen = false;
  const listeners = new Set<() => void>();
  const set = (next: boolean) => {
    if (isOpen === next) return;
    isOpen = next;
    for (const listener of listeners) listener();
  };
  return {
    open: () => set(true),
    close: () => set(false),
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getSnapshot: () => isOpen,
  };
}

/** App-wide instance. Tests create their own via `createSessionExpiredStore`. */
export const sessionExpiredStore = createSessionExpiredStore();

export function useSessionExpiredOpen(store: SessionExpiredStore = sessionExpiredStore): boolean {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
